import ReactDOM from 'react-dom/client';
import 'vest/enforce/schema';
import isEmail from 'validator/es/lib/isEmail';
import { enforce } from 'vest';

enforce.extend({ isEmail });

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App />);
